/* eslint-disable linebreak-style */
// ----------------------------------------------------------------------------
// Component: iam-account-dropdown
// ----------------------------------------------------------------------------
// The iamAccountDropdown class provides a custom element for displaying the
// account dropdown. Login state is rendered server-side (Liquid), so unlike
// iam-cart-dropdown this component only needs to manage open/close behaviour.

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_account-dropdown.scss';

// -------------------------------------
// Web Component
// -------------------------------------

class iamAccountDropdown extends HTMLElement {
  connectedCallback() {
    var _this$parentWrapper, _this$parentWrapper2, _this$parentWrapper3, _this$parentWrapper4;
    // Variables
    this.parentWrapper = this.closest('.account-icon--dropdown');
    this.accountLink = (_this$parentWrapper = this.parentWrapper) === null || _this$parentWrapper === void 0 ? void 0 : _this$parentWrapper.querySelector('.account-dropdown__header-link');

    // Subscribe to native events
    (_this$parentWrapper2 = this.parentWrapper) === null || _this$parentWrapper2 === void 0 || _this$parentWrapper2.addEventListener('focusin', this.focusin.bind(this));
    (_this$parentWrapper3 = this.parentWrapper) === null || _this$parentWrapper3 === void 0 || _this$parentWrapper3.addEventListener('focusout', this.focusout.bind(this));
    (_this$parentWrapper4 = this.parentWrapper) === null || _this$parentWrapper4 === void 0 || _this$parentWrapper4.addEventListener('keyup', this.keyup.bind(this));
  }

  /**
   * Handles the focusin event.
   * Adds the '--open' class and updates tabindex values.
   */
  focusin() {
    var _this$parentWrapper5;
    if (!((_this$parentWrapper5 = this.parentWrapper) !== null && _this$parentWrapper5 !== void 0 && _this$parentWrapper5.classList.contains('--open'))) {
      this.parentWrapper.classList.add('--open');
      var tabIndexItems = this.querySelectorAll('[tabindex="-1"]');
      tabIndexItems.forEach(tabIndexItem => {
        tabIndexItem.setAttribute('tabindex', '0');
      });
    }
  }

  /**
   * Handles the focusout event.
   * Removes the '--open' class.
   */
  focusout() {
    var _this$parentWrapper6;
    if ((_this$parentWrapper6 = this.parentWrapper) !== null && _this$parentWrapper6 !== void 0 && _this$parentWrapper6.classList.contains('--open')) {
      this.parentWrapper.classList.remove('--open');
    }
  }

  /**
   * Handles the keyup event.
   * Closes the dropdown when the 'Escape' key is pressed.
   */
  keyup(e) {
    var _this$parentWrapper7;
    if (e.key === 'Escape' && (_this$parentWrapper7 = this.parentWrapper) !== null && _this$parentWrapper7 !== void 0 && _this$parentWrapper7.classList.contains('--open')) {
      var _this$accountLink;
      (_this$accountLink = this.accountLink) === null || _this$accountLink === void 0 || _this$accountLink.focus();
      this.parentWrapper.classList.remove('--open');
    }
  }
}

// Define the custom element
customElements.define('iam-account-dropdown', iamAccountDropdown);